var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.916,
    height: 19.898,
    viewBox: "0 0 19.916 19.898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M10,12.124a4.6,4.6,0,0,0,6.94.5L19.7,9.86a4.6,4.6,0,1,0-6.508-6.508L11.611,4.927",
    transform: "translate(-2.632 -2.005)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M13.044,10.84a4.6,4.6,0,0,0-6.94-.5L3.343,13.1a4.6,4.6,0,1,0,6.508,6.508l1.573-1.574",
    transform: "translate(-1.995 -2.562)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLinkIcon);
export default __webpack_public_path__ + "static/media/payment-link-icon.4c4efc3aefb94ab77888be56a3dabb41.svg";
export { ForwardRef as ReactComponent };